import { lazy } from 'react'

import { ERoutePaths, type TRoutePageType } from './types'

const Home = lazy(() => import('pages/Home'))
const Information = lazy(() => import('pages/Information'))
const SubCategory = lazy(() => import('../../entities/SubCategoryTabs/index'))
const Catalog = lazy(() => import('pages/Catalog'))
const Wishlist = lazy(() => import('pages/WishList'))
const Product = lazy(() => import('pages/Product'))
const Basket = lazy(() => import('pages/Order'))
const Cart = lazy(() => import('pages/Cart'))
const OrderSuccess = lazy(() => import('pages/OrderSuccess'))
const Error = lazy(() => import('pages/Error'))
const Agreement = lazy(() => import('pages/Agreement'))
const FAQ = lazy(() => import('pages/FAQ'))
const Contacts = lazy(() => import('pages/Contacts/Contacts'))

const routesList: TRoutePageType[] = [
  {
    element: Home,
    path: ERoutePaths.Home,
    title: 'Buy me Home',
  },
  {
    element: Catalog,
    path: ERoutePaths.Catalog,
    title: 'Catalog',
  },
  {
    element: SubCategory,
    path: '/products',
    title: 'Buy me Category',
  },

  {
    element: Product,
    path: ERoutePaths.Product,
    title: 'Buy me Product',
  },

  {
    element: Wishlist,
    path: ERoutePaths.Wishlist,
    title: 'Buy me Wishlist',
  },

  {
    element: Basket,
    path: ERoutePaths.Basket,
    title: 'Buy me Basket',
  },

  {
    element: Cart,
    path: ERoutePaths.Cart,
    title: 'Buy me Cart',
  },

  {
    element: OrderSuccess,
    path: ERoutePaths.OrderSuccess,
    title: 'Order Success',
  },

  {
    element: Information,
    path: ERoutePaths.Information,
    title: 'Buy me Basket',
  },

  {
    element: Error,
    path: ERoutePaths.Error,
    title: 'Error Page',
  },
  {
    element: Agreement,
    path: '/agreement',
    title: 'Agreement',
  },
  {
    element: FAQ,
    path: '/FAQ',
    title: 'FAQ',
  },
  {
    element: Contacts,
    path: '/Contacts',
    title: 'Contacts',
  },
]

export default routesList
